"use client";

import { createContext, useContext, useState } from "react";
import type { ReactNode } from "react";
import { WalletModal } from "@/components/user/global/modals";

interface WalletModalContextValue {
  openWalletModal: () => void;
}

const WalletModalContext = createContext<WalletModalContextValue>({
  openWalletModal: () => {},
});

export function useWalletModal() {
  return useContext(WalletModalContext);
}

export function WalletModalProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <WalletModalContext.Provider
      value={{ openWalletModal: () => setIsOpen(true) }}
    >
      {children}
      <WalletModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </WalletModalContext.Provider>
  );
}
